import { useExtractionDatasetName } from "@/features/data-curation/hooks/useCuration";
import { oldDatasetHref, type DatasetsAccess } from "@/features/datasets/routes";
import { TableProperties } from "lucide-react";
import { Link } from "react-router-dom";

/** Points a main-chat conversation at the old (curator) dataset it created. */
export const OpenInDataCurationLink = ({
  datasetId,
  access,
}: {
  datasetId: string;
  access: DatasetsAccess;
}) => {
  const { data: name } = useExtractionDatasetName(datasetId);
  return (
    <Link
      to={oldDatasetHref(access, datasetId)}
      className="inline-flex max-w-[min(28rem,calc(100%-1.5rem))] items-center gap-1.5 rounded-[3px] border border-zinc-200 bg-white/95 px-2.5 py-1.5 text-xs text-zinc-600 shadow-sm backdrop-blur hover:bg-zinc-50 hover:text-zinc-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900"
    >
      <TableProperties className="h-3.5 w-3.5 shrink-0" aria-hidden />
      <span className="truncate">
        {access.curator === "legacy" ? "Old dataset" : "Working on"}{" "}
        {name ? `“${name}”` : "a dataset"}
      </span>
      <span aria-hidden>·</span>
      <span className="shrink-0 font-medium text-zinc-800">
        {access.curator === "legacy" ? "Open in old Datasets" : "Open in Datasets"}
      </span>
    </Link>
  );
};
